import { DataTable } from "@/core/components/layout/data-table";
import { DashboardFilters } from "@/dashboard/types";
import { useEffect } from "react";
import { useDashboardRankingsSpaces } from "../../hooks/use-dashboard-rankings-spaces";

interface DashboardRankingsSpacesDataTableProps extends React.ComponentPropsWithoutRef<"div"> {
  filters: DashboardFilters;
  setTop3RankingData: (
    data: { position: number; name: string; value: number }[],
  ) => void;
  setIsLoading: (isLoading: boolean) => void;
}

export const DashboardRankingsSpacesDataTable = ({
  filters,
  setTop3RankingData,
  setIsLoading,
  ...props
}: DashboardRankingsSpacesDataTableProps) => {
  const { table, isLoading, top3RankingData } =
    useDashboardRankingsSpaces(filters);

  useEffect(() => {
    setTop3RankingData(top3RankingData);
    setIsLoading(isLoading);
  }, [top3RankingData, isLoading]);

  return (
    <div {...props}>
      <DataTable table={table} isLoading={isLoading} withoutPagination={true} />
    </div>
  );
};
